import React from "react";

function MentorBanner({ className = "w-10 h-10" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="134"
      height="134"
      fill="none"
      viewBox="0 0 134 134"
      className={className}
    >
      <path
        fill="url(#paint0_linear_749_8061)"
        d="M131.765 84.13c-9.447 35.714-46.182 57.081-81.895 47.635C14.156 122.318-7.211 85.583 2.235 49.87 11.682 14.156 48.417-7.211 84.13 2.235c35.714 9.447 57.081 46.182 47.635 81.895zM23.303 55.44c-6.372 24.092 8.044 48.886 32.136 55.257 24.093 6.372 48.887-8.044 55.258-32.136 6.372-24.093-8.044-48.887-32.136-55.258-24.093-6.372-48.887 8.044-55.258 32.136z"
      ></path>
      <path
        fill="#fff"
        d="M77.167 121.044l-1.243.151-.05 1.051 1.243-.15-.05 1.132-1.253.15-.08 1.844-1.142.14.08-1.843-1.172.15-.08 1.843-1.142.14.09-1.853-1.242.15.04-1.132 1.252-.15.04-1.052-1.262.161.04-1.142 1.272-.161.08-1.833 1.143-.14-.08 1.823 1.181-.15.08-1.834 1.143-.14-.08 1.823 1.232-.15-.04 1.172zm-2.435 1.343l.05-1.042-1.172.14-.04 1.052 1.162-.15zM85.06 115.334l2.184 7.744-1.512.43-1.423-5.018-1.172 4.207-.17.06-3.186-2.965 1.413 4.999-1.523.43-2.184-7.743 1.573-.441 3.256 3.025 1.172-4.277 1.573-.451zM90.15 120.173l3.095-1.373.621 1.383-4.548 2.023-3.266-7.353 4.498-1.993.611 1.382-3.045 1.353.691 1.562 2.785-1.232.611 1.363-2.785 1.232.732 1.653zM95.249 110.095l1.352-.822 4.177 6.883-1.031.621-5.5-2.415 2.554 4.208-1.352.821-4.177-6.872 1.031-.621 5.49 2.404-2.544-4.207zM101.65 105.276l.942 1.182-1.693 1.353 4.067 5.099-1.242.992-4.068-5.099-1.693 1.342-.941-1.182 4.628-3.687zM111.457 105.256c.02 1.142-.37 2.134-1.182 2.976-.811.841-1.783 1.272-2.925 1.292-1.142.02-2.134-.371-2.985-1.182-.842-.812-1.282-1.793-1.302-2.935-.021-1.142.37-2.134 1.172-2.976.801-.841 1.783-1.272 2.925-1.302 1.142-.03 2.144.371 2.985 1.182.852.812 1.292 1.793 1.312 2.945zm-4.117 2.715a2.512 2.512 0 001.813-.821c.511-.531.762-1.142.752-1.844-.01-.701-.291-1.312-.842-1.843-.551-.531-1.182-.791-1.883-.771-.701.01-1.313.29-1.823.821-.511.531-.762 1.152-.742 1.854.01.701.301 1.322.852 1.853.541.521 1.172.771 1.873.751zM116.727 99.977l-3.216-.29-.691.981 2.284 1.613-.912 1.292-6.561-4.648 1.853-2.624a2.54 2.54 0 011.733-1.093c.731-.12 1.392.03 1.993.451.411.29.702.671.882 1.152.18.481.23.972.13 1.473l3.506.3-1.001 1.393zm-6.993-1.483l1.944 1.373.941-1.333c.171-.24.231-.52.161-.831-.07-.31-.241-.561-.501-.751a1.2 1.2 0 00-.872-.22.979.979 0 00-.721.43l-.952 1.332z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_749_8061"
          x1="49.872"
          x2="84.133"
          y1="131.768"
          y2="2.225"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.292" stopColor="#5F2EEA"></stop>
          <stop offset="0.448" stopColor="#7E57EE" stopOpacity="0.783"></stop>
          <stop offset="0.615" stopColor="#CDBDF8" stopOpacity="0"></stop>
          <stop offset="0.724" stopColor="#E6DEFC" stopOpacity="0"></stop>
          <stop offset="0.875" stopColor="#E6DEFC" stopOpacity="0"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default MentorBanner;
